import { render, staticRenderFns } from "./CustomersList.vue?vue&type=template&id=1f9d2e59&scoped=true&"
import script from "./CustomersList.vue?vue&type=script&lang=js&"
export * from "./CustomersList.vue?vue&type=script&lang=js&"
import style0 from "./CustomersList.vue?vue&type=style&index=0&id=1f9d2e59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9d2e59",
  null
  
)

export default component.exports